import React from 'react';

export function DBALogo(props: React.SVGProps<SVGSVGElement>): JSX.Element {
    return (
        <svg
            width="76"
            height="49"
            viewBox="0 0 76 49"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clip-path="url(#clip0_5429_2606)">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M17.2558 9.14486H21.7099C22.0149 9.1414 22.2655 9.3842 22.2706 9.68822V38.5797C22.2673 38.7241 22.2062 38.8612 22.1009 38.9604C21.9955 39.0596 21.8547 39.1126 21.7099 39.1076H17.9099C17.5857 39.0989 17.2951 38.9058 17.1624 38.6108L16.6951 37.3843C14.8951 38.9493 12.5893 39.8146 10.2009 39.8217C4.5787 39.8217 0 35.0401 0 29.1562C0 23.2723 4.5787 18.4907 10.2009 18.4907C12.5916 18.5005 14.8981 19.3717 16.6951 20.9436V9.6727C16.6984 9.52829 16.7595 9.39119 16.8648 9.29202C16.9702 9.19284 17.111 9.13984 17.2558 9.14486ZM5.591 29.1717C5.591 32.1214 8.08281 34.5122 11.1509 34.5122C14.2189 34.5122 16.7107 32.1214 16.7107 29.1717C16.7107 26.222 14.2189 23.8312 11.1509 23.8312C8.08281 23.8312 5.591 26.222 5.591 29.1717Z"
                    fill="#00098A"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M33.6363 20.9377C35.431 19.3626 37.7391 18.4913 40.1306 18.486C45.7528 18.486 50.3315 23.2807 50.3315 29.1616C50.3315 35.0425 45.7528 39.8217 40.1306 39.8217C37.7399 39.8119 35.4333 38.9411 33.6363 37.37L33.1691 38.5959C33.0315 38.8866 32.7439 39.0777 32.4216 39.0924H28.6216C28.4768 39.0974 28.336 39.0444 28.2306 38.9453C28.1253 38.8462 28.0642 38.7092 28.0609 38.5648V9.67243C28.0642 9.5281 28.1253 9.39107 28.2306 9.29194C28.336 9.19281 28.4768 9.13984 28.6216 9.14486H33.0757C33.2205 9.13984 33.3613 9.19281 33.4666 9.29194C33.572 9.39107 33.6331 9.5281 33.6363 9.67243V20.9377ZM33.6364 29.1461C33.6364 32.0943 36.1282 34.4839 39.1962 34.4839C42.2643 34.4839 44.7561 32.0943 44.7561 29.1461C44.7561 26.1979 42.2643 23.8083 39.1962 23.8083C36.1282 23.8083 33.6364 26.1979 33.6364 29.1461Z"
                    fill="#00098A"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M71.1808 19.2541H75.3078C75.4526 19.2491 75.5934 19.3021 75.6988 19.4013C75.8041 19.5006 75.8652 19.6377 75.8685 19.7822V38.6533C75.8652 38.7977 75.8041 38.9349 75.6988 39.0341C75.5934 39.1333 75.4526 39.1864 75.3078 39.1814H71.5078C71.1836 39.1727 70.893 38.9795 70.7603 38.6843L70.293 37.4573C68.493 39.023 66.1872 39.8888 63.7988 39.8958C58.1766 39.8958 53.5979 35.112 53.5979 29.2255C53.5979 23.339 58.1766 18.5552 63.7988 18.5552C66.1882 18.5566 68.4959 19.4231 70.293 20.9937L70.5266 19.7667C70.6043 19.4686 70.872 19.2589 71.1808 19.2541ZM64.7488 34.5529C67.8012 34.5529 70.293 32.1765 70.3086 29.241V29.1789C70.293 26.2434 67.8168 23.867 64.7488 23.867C61.6807 23.867 59.1889 26.2589 59.1889 29.2099C59.1889 32.161 61.6963 34.5529 64.7488 34.5529Z"
                    fill="#00098A"
                />
            </g>
            <defs>
                <clipPath id="clip0_5429_2606">
                    <rect
                        width="75.8684"
                        height="31"
                        fill="white"
                        transform="translate(0 9)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
